<template>
<div >
    <div class="primary-heading text-capitalize" >
        Welcome back, {{userName}}!
    </div>
    <div class="secondary-heading w600">
        It looks like you already have an account created in {{orgTitle}}.
    </div>
    <div class="email-img-wrap mt-2">
        <img src="@/assets/images/newui/userexist_4x.png" alt="">
    </div>
    <div class="secondary-heading w600 mt-2" >
        <p class="title-text mt-4">To create a brochure or marketing piece please log into your account through our main login page found here.  <br> If you forgot your password just use the “Forgot My Password”
                feature under the login box. </p>
    </div>

    <div class="secondary-heading w600 mt-2" >
        <p class="title-text mt-4">Need a refresher? Check out our quick start guide.</p>
    </div>

    <div class="sa-frm-row mt-4 mb-1" >
        <!-- <img src="@/assets/images/newui/video_placeholder.png" alt="" style="max-width:100%;"> -->
        <iframe width="600" height="600" src="https://www.youtube.com/embed/qJ2Jp7ZI9XQ" style="height:400px !important"></iframe>
    </div>
    <div class="state-agent" style="width:100%;">
        <div class="sa-frm-row mb-0">
            <div class="ob-btn-wrapper" style="border-top:none;float:right;">
                <button  class="ob-button" style = "align-items:center" @click = "navigateToWorbix">Log into your account</button>
                <!-- <div  class="rotate-btn-wrap" style = "align-items:center">
                    <div class="loader"></div>
                </div> -->
            </div>
        </div>
    </div>
</div>


</template>

<script>
// @ is an alias to /src

import {
	serverUrl,
	uiHostUrl,
    appEnv
} from '../properties';
export default {
    name: 'ExistingUser',
    props: {
        userName: String
    },
    computed:{
        orgTitle (){
            return this.$store.state.orgTitle
        }
    },
	methods:{
        navigateToWorbix(){
            setTimeout(()=>{
                window.location.href = uiHostUrl;
            }, 20);
            window.parent.postMessage({message: 'goToWorbixApp'}, '*');
        }
	}
}
</script>

<style lang="scss">


</style>
